/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import { isSSR } from '@front10/utils';
import { getFares } from '../../../../_integrations/everymundo/fares';
import { getAirports } from '../../../../_integrations/everymundo/airports';
import { makeSureTheseAreFlatFares } from '../../../../_integrations/everymundo/utils/normalizeFareLikeData';

const commonPlainFaresPreload = (
  cmpConfig,
  clientPromises,
  ssrPromises,
  initialFaresPropertyName = 'initialFares',
  getFaresFn = getFares
) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: { integrationSettings, prePopulation, faresTrasformationLogic, meta, pageContext }
      },
      name,
      simulateSSR
    } = cmpConfig;

    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(
        getFaresFn(prePopulation, integrationSettings, faresTrasformationLogic, meta, pageContext)
      );
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([other, fares]) => {
        cmpConfig.containerConfig.settings.getFares = getFaresFn;
        cmpConfig.containerConfig.settings.getAirports = getAirports;
        cmpConfig.containerConfig.settings[initialFaresPropertyName] = fares;
        // Fares Schema Implementation -> https://everymundo.atlassian.net/browse/FC-1700
        cmpConfig.containerConfig.settings.normalizedFlatFaresForSchema = makeSureTheseAreFlatFares(
          fares
        );
        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

export default commonPlainFaresPreload;
